import React from "react";
import Wysiwyg from "../../../components/Wysiwyg/Wysiwyg";
import ToolbarBase from "../../../components/Wysiwyg/toolbar/ToolbarBase";

const EditorTevekenyseg = (props) => {

    const { onChange, fontId, field, addImage, removeImage } = props;

    return (
        <Wysiwyg
            value={field}
            onChange={onChange}
            onImageUpload={addImage}
            onImageRemove={removeImage}
            toolbar={() => <ToolbarBase />}
        />
    );
};

export default EditorTevekenyseg;